import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";

export const fetchTags = async (
    pageNo: number,
    dataLength: number,
    sorting: any,
    filter: any,
    searchItem: string,
    callback: (response: any) => void,
    errorCallback: (error: any) => void
) => {
    try {
        const offset = dataLength * pageNo - dataLength;
        const baseUrl = `${BASEDOMAIN}/tag/organization/list`;
        const queryParams = new URLSearchParams({
            offset: offset.toString(),
            limit: dataLength.toString(),
            sort: JSON.stringify(sorting),
        });

        // Add search parameter if provided
        if (searchItem && searchItem.trim()) {
            queryParams.append('search', searchItem.trim());
        }

        // Add filter parameters
        if (filter?.createdAtStart) {
            queryParams.append('created_on_or_after', filter.createdAtStart);
        }

        if (filter?.createdAtEnd) {
            queryParams.append('created_on_or_before', filter.createdAtEnd);
        }

        if (filter?.status?.value !== undefined && filter?.status?.value !== null && filter?.status?.value !== '') {
            queryParams.append('status', filter.status.value.toString());
        }

        const url = `${baseUrl}?${queryParams.toString()}`;
        const response = await axios.get(url, AuthConfig());
        callback(response);
    } catch (error: any) {
        console.error('Error fetching tags:', error);
        errorCallback(error);
    }
};

export const deleteTag = async (id: any, callback: any, errorCallback: any) => {
    axios.delete(`${BASEDOMAIN}/tag/${id}`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
}

export const addTag = async (tagName: string, callback: any, errorCallback: any) => {
    axios.post(`${BASEDOMAIN}/tag`, { name: tagName }, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
}

export const editTag = async (id: any, tagData: string | { name?: string; color?: string }, callback: any, errorCallback: any) => {
    // Support both old signature (tagName: string) and new signature (tagData: object)
    const requestData = typeof tagData === 'string' 
        ? { name: tagData } 
        : tagData;
    
    axios.patch(`${BASEDOMAIN}/tag/${id}`, requestData, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e);
            console.log(e);
        });
}
